import { Component, OnInit } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule, RouterOutlet } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { CommonModule } from '@angular/common';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})

export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    // Inyectar para inicializar el tema al arrancar
    private themeService: ThemeService
  ) {

  }
  bandera: boolean = false;

  ngOnInit(): void {
    // console.log("onInit AppComponent");
    // this.bandera = this.authService.isLoggedIn();
    // console.log(this.bandera);

  }
}
